module.exports = __webpack_public_path__ + "static/media/info-button.308ad51b.svg";